/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Source_Lot_PlaceholderInputs */

const vi_sl_new_source_lot_placeholder = /** @type {(inputs: Sl_New_Source_Lot_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô chè mua...`)
};

/**

* @param {Sl_New_Source_Lot_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_source_lot_placeholder = /** @type {((inputs?: Sl_New_Source_Lot_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Source_Lot_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_source_lot_placeholder(inputs)
});